import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProgramAgregatedRisksComponent } from './program-agregated-risks.component';

const routes: Routes = [
  {
    path: '',
    component: ProgramAgregatedRisksComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProgramAgregatedRisksRoutingModule { }
